// actions.js
import * as types from "../../actionTypes";

export const fetchCountriesRequest = (keyword) => ({
  type: types.FETCH_COUNTRIES_REQUEST,
  payload:  keyword ,
});

export const fetchCountriesSuccess = (data) => ({
  type: types.FETCH_COUNTRIES_SUCCESS,
  payload:  data ,
});

export const fetchCountriesFailure = (error) => ({
  type: types.FETCH_COUNTRIES_FAILURE,
  payload:  error ,
});

